// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-nav-bar-container {
    z-index: 1200;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 5%;
    width: 90%;
    height: 60px;
    /* background: var(--public-portal-card); */
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(89.92deg, #0357a6 0.08%, #188484 86.41%, #188484 99.93%);
    border-radius: 150px;
}
`, "",{"version":3,"sources":["webpack://./src/components/responsiveAppBar/bottomResponsiveAppBar/MobileBottomAppBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,2CAA2C;IAC3C,mJAAmJ;IACnJ,oBAAoB;AACxB","sourcesContent":[".bottom-nav-bar-container {\n    z-index: 1200;\n    margin-bottom: 10px;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    position: fixed;\n    bottom: 0;\n    left: 5%;\n    width: 90%;\n    height: 60px;\n    /* background: var(--public-portal-card); */\n    background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(89.92deg, #0357a6 0.08%, #188484 86.41%, #188484 99.93%);\n    border-radius: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
